import React, { useState, useRef, useEffect } from "react"
import { useCarnetAdresse } from "gatsby-theme-blank/src/components/Home/MapCarnetAdresse/map-carnet-adresse-query"
import LeafletMap from "gatsby-theme-blank/src/components/Map/leafletmap"
import Leaflet from "leaflet"
import { Marker, Popup } from "react-leaflet"
import {
  container,
  infosContainer,
  mapContainer,
  filtersTaxoItem,
  popupInfos,
  listAddressesTitle,
  listAddressesHeader,
  listAddressesTaxo,
  addressesDescription,
} from "./map-carnet-adresse.module.scss"
import {
  coverSpeed,
  initialZoom,
} from "gatsby-theme-cactus/src/gatsby-theme-blank/constants"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import {
  ListAdressesHeader,
  AllBtn,
  ListAdressesFiltersTaxo,
} from "./map-carnet-adresse-styled"
import redMarker from "gatsby-theme-blank/src/components/Map/images/red-marker.png"
import { isDomAvailable } from "gatsby-theme-blank/src/components/Map/lib/util"
import MarkerClusterGroup from "react-leaflet-markercluster"
import "leaflet/dist/leaflet.css"
import "react-leaflet-markercluster/dist/styles.min.css"
import Obfuscate from "react-obfuscate"
import ContentTransformer from "gatsby-theme-blank/src/components/Transformers/content-transformer"

const ChangeMapMarkers = (adresse, ref) => {
  useEffect(() => {
    const correspondingMarker = ref.current
      .filter(
        (element) =>
          element?.current?.props.position[0] ===
            adresse?.node.field_coordon?.lat &&
          element?.current?.props.position[1] ===
            adresse?.node.field_coordon?.lon
      )
      .shift()
    if (correspondingMarker !== undefined && adresse?.node.field_coordon) {
      correspondingMarker.current.leafletElement.openPopup()
    }
  })
}

//-----------------------Parent component---------------------------//

const CarnetAdresse = () => {
  /**
   * mapEffect
   * @description Fires a callback once the page renders
   * @example Here this is and example of being used to zoom in and set a popup on load
   */

  async function mapEffect({ leafletElement: map } = {}) {
    if (!map) return null
  }
  const buildColors = useBuildData().theme_settings.palette
  const data = useCarnetAdresse()
  let adresses = data.allNodeCarnetDAdresse.edges
  const allTaxo = []
  adresses.map(({ node }) => {
    const arrayTaxo = node.relationships.field_taxonomie_thematique
    allTaxo.push(
      ...arrayTaxo
        .map((element) => {
          return node.field_coordon ? element.name : null
        })
        .filter((element) => element)
    )
  })
  const uniqueTaxos = [...new Set(allTaxo)]
  const initialAdress = adresses
    .filter(({ node }) => node.field_coordon)
    .shift()
  const [choosenTaxo, setChoosenTaxo] = useState(null)
  const markerRef = useRef(
    [...new Array(adresses.length)].map(() => React.createRef())
  )
  const toggleTaxo = (taxoChoisie, nameTaxo) => {
    if (taxoChoisie === nameTaxo) {
      setChoosenTaxo(null)
    } else {
      setChoosenTaxo(nameTaxo)
    }
  }

  const [mapSettings, setMapSettings] = useState({
    center: [
      initialAdress?.node.field_coordon.lat ?? 46,
      initialAdress?.node.field_coordon.lon ?? 2,
    ],
    defaultBaseMap: "OpenStreetMap",
    zoom: initialZoom,
    mapEffect,
  })

  useEffect(() => {
    let choosenAdress
    if (choosenTaxo !== null) {
      choosenAdress = adresses[0]
    } else {
      choosenAdress = initialAdress
    }
    if (choosenAdress?.node?.field_coordon) {
      setMapSettings({
        center: [
          choosenAdress?.node.field_coordon.lat,
          choosenAdress?.node.field_coordon.lon,
        ],
        defaultBaseMap: "OpenStreetMap",
        zoom: initialZoom,
        mapEffect,
      })
    }
  }, [choosenTaxo, adresses, initialAdress])

  if (choosenTaxo !== null) {
    adresses = adresses.filter(({ node }) => {
      if (node.field_coordon) {
        for (
          let cpt = 0;
          cpt < node.relationships.field_taxonomie_thematique.length;
          cpt++
        ) {
          if (
            node.relationships.field_taxonomie_thematique[cpt].name ===
            choosenTaxo
          ) {
            return true
          }
        }
      }
      return false
    })
    ChangeMapMarkers(adresses[0], markerRef)
  } else {
    ChangeMapMarkers(initialAdress, markerRef)
  }

  let customIcon = null
  if (isDomAvailable()) {
    customIcon = new Leaflet.Icon({
      iconUrl: redMarker,
      iconAnchor: [19, 15],
      iconSize: [35, 35],
    })
  }
  if (adresses.length === 0) {
    return null
  }
  return (
    <section className={container}>
      <div className={mapContainer}>
        {/* leaftlet map */}
        <LeafletMap
          style={{ width: "100%", height: "100%" }}
          className="markercluster"
          {...mapSettings}
        >
          <MarkerClusterGroup>
            {adresses.map(({ node }, key) => {
              const {
                drupal_id,
                title,
                field_coordon,
                field_adresse,
                field_mail,
                field_telephone,
              } = node
              if (!field_coordon) {
                return null
              }
              const position = [field_coordon.lat, field_coordon.lon]
              return (
                <Marker
                  ref={markerRef.current[key]}
                  key={drupal_id}
                  position={position}
                  icon={customIcon}
                >
                  <Popup className={popupInfos}>
                    <b>{title}</b>
                    <p>{field_adresse.address_line1}</p>
                    {field_adresse.address_line2 && (
                      <p>{field_adresse.address_line2}</p>
                    )}
                    <p>{field_adresse.postal_code}</p>
                    <p>{field_adresse.locality}</p>
                    <b>
                      <Obfuscate email={field_mail} />
                    </b>
                    <br />
                    <b>
                      <Obfuscate tel={field_telephone} />
                    </b>
                    <br />
                    <AllBtn
                      cover
                      direction="down"
                      bg={buildColors.b_color_gradients.b_dark}
                      duration={coverSpeed}
                      className="btn"
                      to={node.path.alias}
                    >
                      En savoir plus
                    </AllBtn>
                  </Popup>
                </Marker>
              )
            })}
          </MarkerClusterGroup>
        </LeafletMap>
        <div className={infosContainer}>
          <ListAdressesHeader className={listAddressesHeader}>
            <h2 className={listAddressesTitle}>
              {data.taxonomyTermZoneDefinie?.field_label ||
                "Carnet d'addresses"}
            </h2>
            <div className={listAddressesTaxo}>
              {uniqueTaxos.slice(0, 6).map((element, key) => {
                let activeBool = false
                if (choosenTaxo === element) {
                  activeBool = true
                }
                return (
                  <ListAdressesFiltersTaxo
                    onClick={() => {
                      toggleTaxo(choosenTaxo, element)
                    }}
                    onKeyDown={() => {
                      toggleTaxo(choosenTaxo, element)
                    }}
                    key={key}
                    activeBool={activeBool}
                    className={filtersTaxoItem}
                  >
                    {element}
                  </ListAdressesFiltersTaxo>
                )
              })}
            </div>
            <AllBtn
              cover
              direction="down"
              bg={buildColors.b_color_gradients.b_dark}
              duration={coverSpeed}
              className="btn"
              to="/adresses"
            >
              Tout voir
            </AllBtn>
          </ListAdressesHeader>
          {data.taxonomyTermZoneDefinie.description && (
            <div className={addressesDescription}>
              <ContentTransformer
                content={data.taxonomyTermZoneDefinie.description.processed}
              ></ContentTransformer>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

//-----------------------Parent component---------------------------//

//-----------------------Prop-Types---------------------------//

//-----------------------Parent component---------------------------//

export default CarnetAdresse
